import { useTranslation } from 'react-i18next';

export const useLanguage = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  const getCurrentLanguage = () => {
    return i18n.language;
  };

  const isLanguage = (lang) => {
    return i18n.language === lang;
  };

  return {
    changeLanguage,
    getCurrentLanguage,
    isLanguage,
    availableLanguages: [
      { code: 'zh', name: '中文', flag: '🇨🇳' },
      { code: 'en', name: 'English', flag: '🇺🇸' }
    ]
  };
};